var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0527344,
    y: 0.405273,
    width: 41.1899,
    height: 41.1899,
    rx: 18.3003,
    fill: "#31B7A9",
    fillOpacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.33333,
    transform: "matrix(-1 0 0 1 18.9831 16.8333)",
    fill: "#31B7A9",
    stroke: "#31B7A9",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1484 25.1119C13.1484 24.3949 13.5991 23.7554 14.2743 23.5142C17.3185 22.427 20.6451 22.427 23.6892 23.5142C24.3644 23.7554 24.8151 24.3949 24.8151 25.1119V26.2082C24.8151 27.1977 23.9387 27.9578 22.9591 27.8179L22.1637 27.7042C20.0531 27.4027 17.9104 27.4027 15.7998 27.7042L15.0044 27.8179C14.0249 27.9578 13.1484 27.1977 13.1484 26.2082V25.1119Z",
    fill: "#31B7A9",
    stroke: "#31B7A9",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8151 20.167H28.1484",
    stroke: "#31B7A9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4805 18.4997L26.4805 21.833",
    stroke: "#31B7A9",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.f52fbd4bf34eeb21e776ab45f4f79d08.svg";
export { ForwardRef as ReactComponent };